import React from "react";
import "./AdminCategory.css";

const AdminCategoryButton = (props) => {
    return (
        <div className="category_button" onClick={props.onClickFuntion}>
            <div className="category_button_name">{props.name}</div>
        </div>
    );
};

export default AdminCategoryButton;
